<div class="container">
  <div class="ui-g">
    <label class="titulo texto-cinza" *ngIf="titulo">
      {{ titulo }}
    </label>
    <div [ngClass]="( valorQrcode ? 'ui-g-10' : 'ui-g-12' )">

      <p-fileUpload
        #fileUpload
        name="{{nomeDoArquivo}}"
        [url]="url"
        multiple="multiple"
        [accept]="accept"
        [files]="arquivos"
        [maxFileSize]="maxFileSizeMb === null ? null : maxFileSizeMb * 1000000"
        [fileLimit]="fileLimit"
        [chooseLabel]="'&nbsp; Selecionar'"
        [styleClass]="'my-file'"
        [mode]="'advanced'"
        (onRemove)="onRemove($event)"
        (onSelect)="onSelect($event)"
        (onError)="onError($event)"
        (onBeforeSend)="onBeforeSend($event)"
        (onBeforeUpload)="onBeforeUpload($event)"
        (onUpload)="onUpload($event)"
        [showUploadButton]="false"
        [showCancelButton]="false"
        [invalidFileSizeMessageSummary]="'{0}: Tamanho do arquivo inválido, '"
        [invalidFileSizeMessageDetail]="'tamanho máximo: {0}.'"
        [invalidFileLimitMessageSummary]="'Quantidade de anexos excedida, '"
        [invalidFileLimitMessageDetail]="'limite: {0} arquivo(s).'"
        [auto]="autoUpload">

        <ng-template pTemplate="toolbar">
          <span class="toolbar" *ngIf="maxFileSizeMb && maxFileSizeMb > 0">
            Tamanho máximo por arquivo: {{ maxFileSizeMb }} Mb.
          </span>

          <button
            class="botao botao-upload ui-button-info"
            type="button"
            pButton
            (click)="upload()"
            label="Enviar"></button>

          <button
            class="botao botao-cancelar ui-button-secondary"
            type="button"
            pButton
            (click)="cancelar()"
            label="Cancelar"></button>

        </ng-template>

        <ng-template pTemplate="content">
          <div class="drop-zone" *ngIf="exibirDropZone">

            <label *ngIf="valorQrcode" class="drop-zone-label drop-zone-label-color">{{labelSolteArquivoCustomizado ? labelSolteArquivoCustomizado : 'Solte o arquivo aqui ou utilize o QR-Code com nosso app'}}</label>
            <label *ngIf="!valorQrcode" class="drop-zone-label drop-zone-label-color">{{labelSolteArquivoCustomizado ? labelSolteArquivoCustomizado : 'Solte o arquivo aqui'}}</label>

            <div>
              <i class="drop-zone-label-color drop-zone-label-icon material-icons">cloud_upload</i>
            </div>
          </div>
        </ng-template>
      </p-fileUpload>
    </div>

    <div class="ui-g-2 container-qrcode" *ngIf="valorQrcode">
      <qrcode
        [qrdata]="valorQrcode | json"
        [width]="141"
        [errorCorrectionLevel]="'M'"></qrcode>
    </div>
  </div>
</div>

<!-- <mat-drawer #drawer class="container" mode="side">
  <p>Auto-resizing sidenav</p>
</mat-drawer>
<div class="content">
  <button type="button" mat-button (click)="drawer.toggle()">
    <div class="texto-cinza">
      <h1 style="font-weight:normal">Abrir</h1>
    </div>
  </button>
</div> -->
